export const styles = theme => ({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
    },
    paper: {
       // padding: theme.spacing.unit,
       // margin: theme.spacing.unit *2,
       // maxWidth: '400px',
        marginLeft: 0,
        cursor: 'pointer',
        paddingBottom: theme.spacing.unit,
        //minHeight: '12em'
        '&:hover': {
            backgroundColor: '#ECEFF1',
            boxShadow: '2px 2px 2px 2px ' + theme.palette.primary.dark,
           
          }
        
    },
    paperFooter: {
        paddingTop: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit *2,
        textAlign: 'right'
    },
    padding: {
       padding: `0 ${theme.spacing.unit * 2}px`,
      },
      margin: {
        margin: theme.spacing.unit * 2,
      },
      timeLeft: {
        display: 'inline-block',
        color: '#3f51b5',
        textWeight: 'bold',
        marginRight: theme.spacing.unit,
        fontSize: 14,
      },
      header: {
          backgroundColor: '#3f51b5',
          color: 'white',
          textAlign: 'center',
          borderRadius: 4,
          marginBottom: theme.spacing.unit,
          padding: 2    ,
      },
      body: {
          textAlign: 'center',
      },
      requester: {
        name: {
            marginRight: theme.spacing.unit,
            color: 'white'
          },
      },
      color: {

              backgroundColor:'red'
      },
      canidate: {
        marginTop: theme.spacing.unit,
        // borderTop: `2px solid ${theme.palette.secondary.main}`,
        // borderBottom: `2px solid ${theme.palette.secondary.main}`,
        padding: `${theme.spacing.unit /2}px`,
        marginLeft: theme.spacing.unit*2,
        marginRight: theme.spacing.unit*2,
        color: 'white',
        borderRadius: '8px',
        lable: {
            textWeight: 'bold',
        },
        name: {
            textWeight: 'bold',
        }
      },
      connected : {
          backgroundColor: theme.palette.secondary.main,
      },
      confirmed : {
          backgroundColor: 'green'
      },
      confirmedFuture: {
          backgroundColor: theme.palette.primary.main
      }
    
  });


// WEBPACK FOOTER //
// ./src/Components/Admin/stylesAdminCanidateList.js